import React from 'react';
import '../Components/footer.css';
import {FaTwitter, FaFacebookF} from 'react-icons/fa';
import Slide from 'react-reveal/Reveal';
import {Link} from 'react-router-dom'


function Footer() {
  return (
    <div className='footerContainer'>
      
      <Slide left>
        <div className="leftSide">
            <p>&copy; The Cakes Studio {new Date().getFullYear()}</p>
        </div>
        </Slide>
        
        <Slide right>
        <div className="icons">

            <Link className='linkTwit' to={'https://twitter.com'}>
              <FaTwitter className='twit' />
            </Link>
          
            <Link className='linkFace' to={'https://facebook.com'}>
             <FaFacebookF className='face' />
            </Link>
        </div>
        </Slide>

    </div>
  )
}

export default Footer



